import { useQuery } from '@tanstack/react-query';
import { advisorApi } from 'service/api/advisorApi';

export const useGetAllFunds = (enabled: boolean) => {
  const { getAllFunds } = advisorApi();

  return useQuery({
    queryKey: ['allFunds'],
    queryFn: getAllFunds,
    select: (response) => response.data,
    enabled,
  });
};
